// // Need to use the React-specific entry point to import createApi
// import { createApi } from "@reduxjs/toolkit/query/react";

// // Define a service using a base URL and expected endpoints
// export const dashboardApi = createApi({
//     reducerPath: "dashboardApi",
//     baseQuery: encryptedBaseQueryWithReauth(),
//     // baseQuery: encryptedBaseQueryWithReauth(process.env.REACT_APP_LOCAL_URL),
//     tagTypes: ["getDashoardAnalytics"],
//     endpoints: (builder) => ({

//         getDashboardAnalytics: builder.query({
//             query: (endpoint) => `${endpoint}`,
//             providesTags: ["getDashoardAnalytics"],
//         }),
//           getDashboardCounts: builder.query({
//             query: (endpoint) => `${endpoint}`,
//             providesTags: ["getDashboardCounts"],
//         }),
//     }),
// });

// export const {
//     useGetDashboardAnalyticsQuery,
//     useGetDashboardCountsQuery
// } = dashboardApi;


// Need to use the React-specific entry point to import createApi
import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptedBaseQueryWithReauth } from "../utilities/encryptedBaseQuery";

// Define a service using a base URL and expected endpoints
export const dashboardApi = createApi({
  reducerPath: "dashboardApi",
  baseQuery: encryptedBaseQueryWithReauth(),
  tagTypes: ["DashboardAnalytics", "DashboardCounts"], // Tag types should be consistently named
  endpoints: (builder) => ({
    getDashboardAnalytics: builder.query({
      query: (endpoint) => `${endpoint}`, // e.g., "exams/v1/dashboard"
      providesTags: ["DashboardAnalytics"],
    }),
    getDashboardCounts: builder.query({
      query: (endpoint) => `${endpoint}`, // e.g., "exams/v1/dashboard/counts"
      providesTags: ["DashboardCounts"],
    }),
  }),
});

// Export hooks
export const {
  useGetDashboardAnalyticsQuery,
  useGetDashboardCountsQuery,
} = dashboardApi;
